import { getLink } from '../../../../utils/utils';

import author from './author';

const cite1Text = (
  `Все собственные имена и даты в оригинале представлены, как и весь текст вообще, в виде волнового излучения. 
  Наши приборы способны перевести текст, но воспроизвести звуками волновые понятия, которым нет соответствия в нашем языке, невозможно. 
  Поэтому мы, чтобы не плодить сущности без необходимости, не подставляем здесь произвольные звучания, а просто оставляем лакуны.`
)
const cite1 = (
  `<sup><acronym title="${cite1Text}"><a href="#cite_note1" id="cite_ref1">[1]</a></acronym></sup>`
)

const cite2Text = (
  `Разумеется, наблюдатель не мог знать, что земная эволюция просто вернулась к тому, что было испробовано во многих таксонах на ранних стадиях жизни на Земле. 
  В природе ничего не пропадает напрасно; и вот приспособление древних беспозвоночных вновь возникло на высшей пока что точке развития жизни: у Нomo ĉu Sapiens.`
)
const cite2 = (
  `<sup><acronym title="${cite2Text}"><a href="#cite_note2" id="cite_ref2">[2]</a></acronym></sup>`
)

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Я. ()${cite1}, пилот корабля () Космического наздора, посетил планету 3862 в рамках выполнения задания по надзору за маргинальными обитаемыми мирами. 
      </p>
      
      <p class="mb-3">
        Предыдущее посещение было произведено пилотом () на корабле () в (). 
        На планете за это время прошло, по их летоисчислению, примерно 2600 оборотов вокруг их центральной звезды, 
        т.е. срок, указанный по Уставу Наздора для регулярных проверок. 
        Поэтому, следуя правилам, я выбрал очередным пунктом своего наблюдения эту планету и совершил посадку в указанном в Звёздном атласе месте (указаны координаты). 

      </p>
      
      <p class="mb-3">
        Планета оказалась на примерно ожидаемом уровне развития: умеренная машинизация, отсутствие выхода в Космос, 
        отсутствие освоения недр и океанов на уровне, достаточном для вступления в Межгалактический Союз.
      </p>
      
      <p class="mb-3">
        Конкретно: (идёт специальная информация, мало интересная для наших читателей). 
      </p>
      
      <p class="mb-3">
        Но в деле естественной эволюции они сделали такой шаг, какого, насколько мне известно, не наблюдалось на других мирах нашей Системы. 
        Дело касается размножения «разумных» обитателей. 
        На этой планете весьма разнообразная органическая жизнь; многие её представители обладают, по нашим меркам, весьма высокоразвитым интеллектом, 
        однако не создали машинной цивилизации, а предпочли замкнутое развитие только в рамках своего биологического таксона (список таксонов прилагается). 
        Это позволило им сохранить своё местообитание и обеспечить существование без явных конфликтов с окружающими таксонами. 
        Были проведены контакты с (список прилагается); они, без сомнения, разумны, но замкнуты на себе и категорически не стремятся к общению с другими мирами. 
        Предлагаю вернуться к ним специально через некоторое время, внеся необходимые изменения в график посещений Надзора. 
      </p>
      
      <p class="mb-3">
        В настоящее время главенствующей на планете является один-единственный таксон, создавший машинную цивилизацию. 
        Так как время существования этой цивилизации очень незначительно по сравнению со временем существования там органической жизни, то возможно, 
        что его видимое превалирование является просто следствием его относительной молодости, 
        и со временем он выработает более гармоничные сотруднические отношения со своими сожителями на планете. 
      </p>
      
      <p class="mb-3">
        Как на большинстве маргинальных планет, машинная цивилизация и относительная разумность привели преобладающий таксон к т.н. пролиферации, 
        т.е. неконтролируемому размножению. 
        Возникла угроза вытеснения или даже уничтожения в ходе неизбежных внутренних конфликтов остального органического населения планеты. 
        Но здесь эволюция сделала необычный${cite2} ход: она разом вдвое уменьшила число превалирующих особей. 
        Сделано это остроумно и оригинально: самцовые особи существуют только как паразиты в теле самок. 
        Подробности такого изменения изложены в Приложении 6, хотя все детали не ясны постороннему наблюдателю до сих пор. 
      </p>
      
      <p class="mb-3">
        Это изменение, принесшее кардинальные сдвиги в развитии «разумного» таксона на планете, произошло, по нашему мнению, относительно недавно, 
        т.к. на планете сохранились следы гораздо более развитой машинной цивилизации и натуроцида. 
        Возможно, существование только одного проявленного пола является новым шагом в эволюции органического мира. 
        А может, это признак его вырождения. 
        Во всяком случае, наблюдение за планетой 3862 необходимо продолжить.
      </p>


      <p class="mb-5" style="display: flex; justify-content: space-between;">
        <span>Дата: ()</span>
        <span>Пилот ()</span>
      </p>
      
      <p>ПРИЛОЖЕНИЯ:</p>
      <ol>
        <li>Страница Звёздного Атласа с указанием кооррдинат планеты 3862  </li>
        <li>Бортовой журнал звездолёта ()</li>
        <li>Результаты химического исследования газообразного, жидкого и твёрдого вещества планеты 3862</li>
        <li>Список основных таксонов органической жизни на планете 3862</li>
        <li>Материалы контактов с наиболее «разумными» обитателями планеты 3862</li>
        <li>Специальный обзор о мужском паразитизме (для специального пользования)</li>
      </ol>
    </div>
    `
  )
}

const itemName = {
  rus: `Из донесений пилота корабля космического надзора ()`
}

const itemDate = {
  rus: 'Декабрь 2022'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;